
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/user-infos",
      function () {
        return require("private-next-pages/signup/user-infos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/user-infos"])
      });
    }
  